import { z } from 'zod'
import { RouterName } from '@/enums/router-name'
import { ErrorCode, Identity, RewardCategory } from '~library/enums'

export const routerSettingSchema = z.object({
  /** 最新消息 - 內容 */
  [RouterName.NEWS_DETAIL]: z.object({
    params: z.object({
      id: z.string()
    })
  }),
  /** Bizfam 獨享 - 詳細頁 */
  [RouterName.OFFERS_DETAIL]: z.object({
    params: z.object({
      id: z.string()
    })
  }),
  /** 異業合作 - 內容 */
  [RouterName.COOPERATION_DETAIL]: z.object({
    params: z.object({
      id: z.string()
    })
  }),
  /** 信件預覽 */
  [RouterName.MAIL_PREVIEW]: z.object({
    params: z.object({
      guid: z.string()
    })
  }),
  /** 錯誤頁面 */
  [RouterName.ERROR]: z.object({
    params: z.object({
      errorCode: z.nativeEnum(ErrorCode)
    })
  }),
  /** 企業綁定登入會員 */
  [RouterName.COMPANY_EMPLOYEE]: z.object({
    query: z.object({
      token: z.string()
    })
  }),
  /** 更換企業綁定 */
  [RouterName.COMPANY_EMPLOYEE_BIND_CHANGE]: z.object({
    query: z.object({
      inviteToken: z.string()
    })
  }),
  /** 企業綁定 */
  [RouterName.COMPANY_EMPLOYEE_BIND]: z.object({
    query: z.object({
      inviteToken: z.string()
    })
  }),
  /** 差旅人 - 我的禮遇清單 - 列表 */
  [RouterName.TREATMENT_LIST]: z.object({
    query: z.object({
      tab: z.nativeEnum(RewardCategory).optional()
    })
  }),
  /** 差旅經理人 - 禮遇兌換管理 - 禮遇兌換詳細頁面 */
  [RouterName.HOSPITALITY_EXCHANGE_DETAIL]: z.object({
    query: z.object({
      id: z.string(),
      flashSaleId: z.string(),
      limitedEditionDetailId: z.string()
    })
  }),
  /** 邀請信 */
  [RouterName.INVITE_MAIL]: z.object({
    query: z.object({
      identity: z.nativeEnum(Identity),
      lang: z.string(),
      preventStorageLocale: z.literal('Y')
    })
  }),
  /** 差旅人 - 我的行程 - 內容 */
  [RouterName.JOURNEY_HOSPITALITY_ARRANGEMENT_DETAIL]: z.object({
    params: z.object({
      pnr: z.string()
    })
  }),
  [RouterName.HOSPITALITY_AGENT_ARRANGEMENT]: z.object({
    query: z.object({
      /** 來源類型 */
      type: z.string(),
      /** 會員卡號 */
      memberCardNumber: z.string()
    })
  }),
  [RouterName.HOSPITALITY_AGENT_ARRANGEMENT_DETAIL]: z.object({
    params: z.object({
      /** 會員卡號 */
      memberCardNumber: z.string(),
      /** 訂位代號 */
      pnr: z.string()
    })
  }),
  /** 加入我們 - 入會規則與條款 */
  [RouterName.JOIN_US_CORPORATE_IDENTIFIER]: z.object({
    query: z.object({
      /** 企業識別碼 */
      identifier: z.string()
    })
  }),
  /** 加入我們 - 入會規則與條款 */
  [RouterName.JOIN_US_TERMS]: z.object({
    query: z.object({
      /** 企業識別碼 */
      identifier: z.string()
    })
  }),
  /** 加入我們 - 使用企業辨識碼- 寄送邀請信 */
  [RouterName.JOIN_US_CORPORATE_IDENTIFIER_INVITATION]: z.object({
    query: z.object({
      /** 企業識別碼 */
      identifier: z.string()
    })
  }),
  /** 加入我們 - 使用企業辨識碼- 寄送邀請信 */
  [RouterName.JOIN_US_CORPORATE_IDENTIFIER_SUCCESS]: z.object({
    query: z.object({
      /** 企業識別碼 */
      email: z.array(z.string())
    })
  }),
  [RouterName.RESET_LATCH_KEY]: z.object({
    query: z.object({
      /** 企業帳號 */
      account: z.string(),
      /** 企業帳號 */
      email: z.string(),
      /** 企業帳號 */
      type: z.union([z.literal('forget'), z.literal('reset')]),
      /** 錯誤訊息 */
      errMsg: z.string()
    })
  }),
  [RouterName.MY_ACCOUNT]: z.object({
    query: z.object({
      /** 企業帳號 */
      tab: z.string()
    })
  })
})

export interface RouterSetting extends z.infer<typeof routerSettingSchema> {}
